export default __webpack_public_path__ + "static/media/Universe_ Platform 2.58d2bc85.png";